/**
 * TrackEditSuccess
 * 
 * @Author: Focci
 * @Date: 2023-08-17 14:36:29
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-17 14:36:29
 */

import PropTypes from 'prop-types'
import { useTranslations } from 'next-intl'
import TrackTitle from './TrackTitle'
import TrackProperty from './TrackProperty'
import TackAction from './track-form/TackAction'

export default function TrackEditSuccess({
  hideViewButton,
  property = {}
}) {
  const tt = useTranslations('track')
  
  return (
    <div>
      <TrackTitle label={tt('success')} />
      <div className="max-w-[25rem] mx-auto">
        <div className="text-f.8 my-6 text-center">
          {tt('applicationSuccessfullySubmit')}
          <a href="mailto:support@hougarden.com" className="text-primary" data-noprogress>
            support@hougarden.com
          </a>
        </div>
        <TrackProperty data={property} />
      </div>
      <TackAction 
        property={property} 
        hideViewButton={hideViewButton} 
      />
    </div>
  )
}

TrackEditSuccess.propTypes = {
  property: PropTypes.object,
}
